<p-dialog header="{{'Edit Group' | translate}}" [(visible)]="display" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Group Name</label>
      <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="deviceGroupParam.gName"
             required #revInputText="ngModel">
      <p-message severity="error" text="{{'Group Name are required' | translate}}" *ngIf="groupIsErrorFlag.gName && revInputText.errors"></p-message>
    </div>
    <div class="form-group">
      <label translate>Time Zone</label>
      <div class="select">
        <p-select [options]="timezoneOptions" [(ngModel)]="deviceGroupParam.timeZone" appendTo="body"></p-select>
        <p-message severity="error" text="{{'Please select time zone.' | translate}}" *ngIf="groupIsErrorFlag.timeZone && deviceGroupParam.timeZone == null"></p-message>
      </div>
    </div>
    <div class="form-group">
      <label translate>Devices</label>
      <div class="select">
        <p-multiSelect [options]="addDeviceList$ | async" [(ngModel)]="deviceGroupParam.devices_selected" required placeholder="{{'Choose' | translate}}" appendTo="body"></p-multiSelect>
        <!--<p-message severity="error" text="Devices is required" *ngIf="groupIsErrorFlag.devices && deviceGroupParam.devices.length === 0"></p-message>-->
      </div>
    </div>
    <div translate class="alert alert-warning">
      Notices !!!  The time zone of selected devices will be set as same with Group's time zone.
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="updateGroupSave()" label="{{'Save' | translate}}" class="{{Confirm_button}}"></button>
    <button type="button" pButton (click)="display=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>
<p-toast [style]="{marginTop: '70px'}"></p-toast>
